import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Importing development configuration
    gamesCasino, // Importing casino games configuration
    profile, // Importing user profile configuration
    providersCasino, // Importing casino providers configuration
} from 'config/config'; // Importing configuration settings

/**
 * Class representing the view for partner categories table.
 * @extends JetView
 */
export default class tablePartnersCategoriesView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        var list1 = {
            view: 'dbllist', // Double list view for selecting categories
            id: 'dbllist', // Unique identifier for the double list
            list: {
                height: 0, // Height of the list
                scroll: true, // Enable scrolling
            },
            labelLeft: _('Juegos no agregados'), // Label for the left list
            labelRight: _('Juegos Agregados'), // Label for the right list
            data: [], // Initial data for the lists
        };
        return {
            view: 'form', // Form view
            id: 'f1', // Unique identifier for the form
            rows: [
                {
                    view: 'forminput', // Input field for the form
                    name: 'access', // Name of the input field
                    body: list1, // Body of the input field containing the double list
                    labelWidth: 140, // Width of the label
                    labelAlign: 'right', // Alignment of the label
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        var values = ''; // Variable to hold selected values
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        var categorie = ''; // Variable to hold category
        var string1 = ''; // Variable to hold query string for API requests

        // Event listener for filtering partner categories
        this.on(this.app, 'partnerCategories:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            string1 = ''; // Reset query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Categorie') {
                        categorie = object[i][1]; // Set category from filter data
                    }
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filter parameters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            $$('dbllist').$$('left').clearAll(); // Clear left list
            $$('dbllist').$$('right').clearAll(); // Clear left list
            $$('dbllist').setValue([]); // Reset selected values
            webix
                .ajax() // AJAX request to fetch partner categories
                .get(
                    devConfig.geturlApi() + 'PartnersCategories/GetGroupPartnersCategories',
                    string1, // Query string with filters
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message('Error! '); // Error message on failure
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var data = JSON.parse(text); // Parse response data
                            if (!data.HasError) {
                                $$('dbllist').$$('left').clearAll(); // Clear left list
                                $$('dbllist').$$('right').clearAll(); // Clear left list
                                $$('dbllist').setValue([]); // Reset selected values
                                $$('dbllist').parse(
                                    data.Data.ExcludedCategoriesList, // Parse excluded categories
                                );
                                $$('dbllist').setValue(
                                    data.Data.IncludedCategoriesList, // Set included categories
                                );
                                let countLeft = $$("dbllist").$$("left").data.serialize();
                                let countRight = $$("dbllist").$$("right").data.serialize();
                                const [labelLeft, labelRight] = $$("dbllist").queryView({view:"label"}, "all");
                                labelLeft.define("label", _("Juegos no agregados") + " (" + countLeft.length + ")" );
                                labelRight.define("label", _("Juegos Agregados") + " (" + countRight.length + ")" );
                                labelLeft.refresh();
                                labelRight.refresh();
                                values = data.Data.IncludedCategoriesList; // Store included categories
                            } else {
                                webix.message('Error! '); // Error message on failure
                            }
                        },
                    },
                );
        });

        // Event listener for changes in the double list
        $$('dbllist').attachEvent('onChange', function (id, e, node) {
            var array1 = values.split(','); // Split current values into an array
            var array2 = $$('dbllist').getValue().split(','); // Get new values from the double list
            var arrayAgregados = []; // Array to hold added categories
            var arrayEliminados = []; // Array to hold removed categories
            array2.forEach(function (obj) {
                var found = array1.find(function (element) {
                    return element == obj; // Check if the category was already included
                });
                if (found != undefined) {
                    // If found, do nothing
                } else {
                    arrayAgregados.push(obj); // Add to added categories
                }
            });
            array1.forEach(function (obj) {
                var found = array2.find(function (element) {
                    return element == obj; // Check if the category was removed
                });
                if (found == undefined) {
                    arrayEliminados.push(obj); // Add to removed categories
                } else {
                    // If found, do nothing
                }
            });
            webix
                .ui({
                    view: 'window', // Create a confirmation window
                    head: {
                        view: 'toolbar', // Toolbar for the window header
                        cols: [
                            {
                                view: 'label',
                                label: _('Desea realizar movimiento?'), // Confirmation message
                            },
                        ],
                    },
                    position: 'center', // Center the window
                    modal: true, // Make the window modal
                    body: {
                        view: 'form', // Form inside the window
                        id: 'form', // Unique identifier for the form
                        elements: [
                            {
                                view: 'text', // Text input for observations
                                label: _('Observación'), // Label for the input
                                name: 'Note', // Name of the input
                                required: true, // Not required
                                labelWidth: 100, // Width of the label
                            },
                            {
                                cols: [
                                    {
                                        view: 'button', // Cancel button
                                        value: _('Cancelar'), // Button label
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window
                                            $$('form').setValues(
                                                $$('form').getCleanValues(), // Reset form values
                                            );
                                            webix
                                                .ajax() // AJAX request to refresh categories
                                                .get(
                                                    devConfig.geturlApi() +
                                                        'PartnersCategories/GetGroupPartnersCategories',
                                                    string1, // Query string with filters
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var data = JSON.parse(
                                                                text, // Parse response data
                                                            );
                                                            if (!data.HasError) {
                                                                $$('dbllist').$$('left').clearAll(); // Clear left list
                                                                $$('dbllist').setValue([]); // Reset selected values
                                                                $$('dbllist').parse(
                                                                    data.Data.ExcludedCategoriesList, // Parse excluded categories
                                                                );
                                                                $$('dbllist').setValue(
                                                                    data.Data.IncludedCategoriesList, // Set included categories
                                                                );
                                                                let countLeft = $$("dbllist").$$("left").data.serialize();
                                                                let countRight = $$("dbllist").$$("right").data.serialize();
                                                                const [labelLeft, labelRight] = $$("dbllist").queryView({view:"label"}, "all");
                                                                labelLeft.define("label", _("Juegos no agregados") + " (" + countLeft.length + ")" );
                                                                labelRight.define("label", _("Juegos Agregados") + " (" + countRight.length + ")" );
                                                                labelLeft.refresh();
                                                                labelRight.refresh();
                                                                values = data.Data.IncludedCategoriesList; // Store included categories
                                                            } else {
                                                                webix.message(
                                                                    'Error! ', // Error message on failure
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        },
                                    },
                                    {
                                        view: 'button', // Save button
                                        type: 'form', // Button type
                                        value: _('Guardar'), // Button label
                                        click: function ($e) {
                                            var valuesForm = $$('form').getValues(); // Get form values
                                            if ($$('form').validate()) {
                                                // Validate form
                                                var vthis = this; // Reference to the current instance
                                                this.getTopParentView().hide(); // Hide the window
                                                webix
                                                    .ajax() // AJAX request to save categories
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() +
                                                            'PartnersCategories/SaveGroupPartnersCategories',
                                                        '{"Partner":"' +
                                                            id_partner +
                                                            '","Categorie":"' +
                                                            categorie +
                                                            '","IncludedCategoriesList":"' +
                                                            arrayAgregados +
                                                            '","ExcludedCategoriesList":"' +
                                                            arrayEliminados +
                                                            '","Note":"' +
                                                            valuesForm.Note +
                                                            '","CountrySelect":"' +
                                                            $$('CountrySelect').getValue() +
                                                            '"}', // JSON string with data
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message on failure
                                                                );
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var data = JSON.parse(
                                                                    text, // Parse response data
                                                                );
                                                                if (!data.HasError) {
                                                                    webix.message(
                                                                        _(
                                                                            'Categoría Partner Editado', // Success message
                                                                        ),
                                                                    );
                                                                    let countLeft = $$("dbllist").$$("left").data.serialize();
                                                                    let countRight = $$("dbllist").$$("right").data.serialize();
                                                                    const [labelLeft, labelRight] = $$("dbllist").queryView({view:"label"}, "all");
                                                                    labelLeft.define("label", _("Productos no agregados") + " (" + countLeft.length + ")" );
                                                                    labelRight.define("label", _("Productos Agregados") + " (" + countRight.length + ")" );
                                                                    labelLeft.refresh();
                                                                    labelRight.refresh();
                                                                    values = $$('dbllist').getValue(); // Update values with current selection
                                                                } else {
                                                                    webix.message(
                                                                        _('Error! '), // Error message on failure
                                                                    );
                                                                }
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                        },
                                                    );
                                            } else {
                                                webix.message({
                                                    title: _('¡Error!'), // Error title
                                                    type: 'alert-error', // Error type
                                                    text: _(
                                                        'Completa los campos...', // Error message
                                                    ),
                                                });
                                            }
                                        },
                                    },
                                ],
                            },
                        ],
                        elementsConfig: {
                            on: {
                                onChange: function () {
                                    this.validate(); // Validate form on change
                                },
                            },
                        },
                    },
                })
                .show(); // Show the confirmation window
        });
    }
}

// FILE DOCUMENTED
